<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="director.id!=null">{{$t('director.titleEdit')}}</h4>
                                <h4 class="card-title float-left" v-else>{{$t('director.addNew')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group pr-3">
                                  <label>{{$t('common.users')}}<span class="red">*</span></label>
                                  <UserSelect :value="director.user" v-model="director.user"></UserSelect>
                                  <div class="red" v-if="$v.director.user.$error">
                                    {{$t('common.users')}}
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label>{{$t("common.startDate")}}</label>
                                  <custom-date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="director.startDate"
                                      :date="director.startDate"
                                      :clear-button="true">
                                  </custom-date-picker>
                                  <div class="red" v-if="$v.director.startDate.$error">
                                    {{$t('common.startDate')}}
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label>{{$t("common.endDate")}}</label>
                                  <custom-date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="director.endDate"
                                      :date="director.endDate"
                                      :clear-button="true">
                                  </custom-date-picker>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('director.description')}}</label>
                                    <textarea
                                            cols="30" rows="3"
                                            class="form-control"
                                            v-model="director.description"
                                    ></textarea>
                                </div>


                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" v-if="save">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    import CustomDatePicker from '@/views/common/CustomDatePicker';
    import UserSelect from '@/views/common/UserSelect'


    export default {
        name: "DirectorAddEditView",
        components: {
            CustomDatePicker,
            UserSelect
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                director: {
                    id: null,
                    user: null,
                    startDate: null,
                    endDate: null,
                    description: null,
                },
                itemFilter: initFilterModel(),
                results: null
            }
        },
        validations() {
            return {
                director: {
                    user: {
                        required: required
                    },
                    startDate: {
                        required: required
                    }
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/director/' + id)
                        .then(res => {
                            console.log(res);
                            vm.director = res.data;
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.director.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/director', this.director)
                    .then(res => {
                        console.log(res)
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.director.success'),
                            type: 'success'
                        });
                        this.$router.push('/company/director');
                        this.processing = false;
                    }
                    // , (err, data) => {
                    //     console.log(data);
                    //     this.$swal({
                    //         title: this.$t('messages.common.error'),
                    //         text: this.$t('messages.director.error') + '\n' + data,
                    //         type: 'error'
                    //     });
                    //     this.processing = false;
                    // }
                    ).catch(error => {
                      // console.log(error.response);
                      this.$swal({
                          title: this.$t('messages.common.error'),
                          text: this.$t('messages.director.error') + '\n' + error.response.data.message,
                          type: 'error'
                      });
                            this.processing = false;
                    });

            },
            cancel() {
                this.$router.push('/company/director');
            },

        },
        computed: {

        },
        created() {
           this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS",Arial,Helvetica,sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    .custom td,.custom th{
        border: 1px solid #ddd;
        padding: 4px;
    }
    .custom tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .custom tr:hover{
        opacity: 1;
        background-color: #dee2e6;
    }
    .custom thead tr th{
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }
    .custom tr{
        font-size: 14px;
    }

</style>